import { combineReducers } from 'redux';
import { homeReducer } from './home'
import { metaReducer } from './meta'
import { menuReducer } from './menu'
import { mobileReducer } from './mobile'

import Document from '../objects/Document/reducer'
import DocumentType from '../objects/DocumentType/reducer'
import Gender from '../objects/Gender/reducer'
import Region from '../objects/Region/reducer'
import Right from '../objects/Right/reducer'
import Role from '../objects/Role/reducer'
import RoleRight from '../objects/RoleRight/reducer'
import RoleUser from '../objects/RoleUser/reducer'
import User from '../objects/User/reducer'
import UserRight from '../objects/UserRight/reducer'
import Translate from '../objects/Translate/reducer'
import UserConfig from '../objects/UserConfig/reducer'


const rootReducer = combineReducers({
    meta: metaReducer,
    menu: menuReducer,
    home: homeReducer,
    mobile: mobileReducer,

    Document: Document.reducer,
    DocumentType: DocumentType.reducer,
    Gender: Gender.reducer,
    Region: Region.reducer,
    Right: Right.reducer,
    Role: Role.reducer,
    RoleRight: RoleRight.reducer,
    RoleUser: RoleUser.reducer,
    User: User.reducer,
    UserRight: UserRight.reducer,
    UserConfig: UserConfig.reducer,
    Translate: Translate.reducer,
});

export default rootReducer;